import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  packages: [],
  currentPackage: null,
  loading: false,
  error: null,
};

const packageSlice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    fetchPackagesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPackagesSuccess: (state, action) => {
      state.loading = false;
      state.packages = action.payload;
      state.error = null;
    },
    fetchPackagesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setCurrentPackage: (state, action) => {
      state.currentPackage = action.payload;
    },
    createPackageStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createPackageSuccess: (state, action) => {
      state.loading = false;
      state.packages = [...state.packages, action.payload];
      state.error = null;
    },
    createPackageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updatePackageStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updatePackageSuccess: (state, action) => {
      state.loading = false;
      state.packages = state.packages.map((pkg) =>
        pkg.id === action.payload.id ? action.payload : pkg,
      );
      state.currentPackage = action.payload;
      state.error = null;
    },
    updatePackageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deletePackageStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deletePackageSuccess: (state, action) => {
      state.loading = false;
      state.packages = state.packages.filter(
        (pkg) => pkg.id !== action.payload,
      );
      state.error = null;
    },
    deletePackageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchPackagesStart,
  fetchPackagesSuccess,
  fetchPackagesFailure,
  setCurrentPackage,
  createPackageStart,
  createPackageSuccess,
  createPackageFailure,
  updatePackageStart,
  updatePackageSuccess,
  updatePackageFailure,
  deletePackageStart,
  deletePackageSuccess,
  deletePackageFailure,
} = packageSlice.actions;

export default packageSlice.reducer;
